import { css } from 'styled-system/css';

export const searchStyle = {
	searchBar: css({
		_mars: {
			display: 'flex',
			bgColor: 'header.containerBg',
			p: '9px',
			'& .search-input': {
				flex: 1,
				p: '6px',
				bgColor: 'white.1',
			}
		}
	}),
	cancelButton: css({
		base: {
			display: 'none',
		},
		_mars: {
			display: 'flex',
			color: 'white',
			fontSize: 'lg',
		}
	}),
	searchIcon: css({
		base: {
			display: 'none',
		},
		_mars: {
			width: '24px',
			mr: '3px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		}
	}),
	container: css({
		_mars: {
			maxHeight: 'calc(100vh - 60px)',
			overflow: 'auto',
			md: {
				maxHeight: 'calc(100vh - 120px)',
			},
		},
	}),
	searchText: css({
		_mars: {
			'& .search__filter-highlight': {
				color: 'brand.500_light',
			}
		}
	}),
	label: css({
		_mars: {
			color: 'brand.500_light',
		}
	}),
	filter: css({
		_mars: {
			top: 'calc(100% + 9px)',
		},
	}),
};